import type { CelestialBodyDefinition } from "../types/celestialBody";
import { sun } from "./sun";
import { planets } from "./planets";
import { moons } from "./moons";
import { validateCatalog } from "../astronomy/validation";

export const celestialBodyCatalog: CelestialBodyDefinition[] = [
  sun,
  ...planets,
  ...moons,
];

const validationErrors = validateCatalog(celestialBodyCatalog);
if (validationErrors.length > 0 && process.env.NODE_ENV !== "production") {
  console.warn("[TLSAstronauta] Catálogo com avisos:", validationErrors);
}

export const catalogById = new Map(
  celestialBodyCatalog.map((body) => [body.id, body]),
);

export function getBodyById(id: string): CelestialBodyDefinition | undefined {
  return catalogById.get(id);
}

export function getChildrenOf(parentId: string): CelestialBodyDefinition[] {
  return celestialBodyCatalog.filter((b) => b.parentId === parentId);
}

export function getPlanets(): CelestialBodyDefinition[] {
  return celestialBodyCatalog.filter((b) => b.type === "planet");
}

export function getMoons(): CelestialBodyDefinition[] {
  return celestialBodyCatalog.filter((b) => b.type === "moon");
}
